import React, { useState,useEffect } from "react";
import teamIcon from "../../assets/icons/mangment icons/team.png";
import titleIcon from "../../assets/icons/mangment icons/title.png";
import permissionGroupIcon from "../../assets/icons/mangment icons/PermissionGroup.png";
import adminIcon from "../../assets/icons/mangment icons/admin.png";
import { toastMsg } from "../../functions/toastMsg";
import { postData,getData, patchDataToken } from "../../axios/axiosHelper";
import { useNavigate } from "react-router-dom";
import { ADMIN_PAGE_LABELS } from "../../navigation/adminNavigation";

const AddPermissionHooks = (existingPermissionGroup) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [selectedTeamName, setSelectedTeamName] = useState(null);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const handleSelect = (teamId) => {
    const selectedTeam = teams.find((team) => team.id === teamId);
    setSelectedTeamId(teamId);
    setSelectedTeamName(selectedTeam.name);
  };

  const teams = [
    { id: 1, name: "Team A", nameAr: "فريق ب" },
    { id: 2, name: "Team B", nameAr: "فريق ب" },
    { id: 3, name: "Team C", nameAr: "فريق ب" },
  ];

  const [search, setSearch] = useState(false);

  const NavItems = [
    {
      name: ADMIN_PAGE_LABELS.roles,
      to: "/management/permissiongroup/addpermissiongroup",
      icon: permissionGroupIcon,
    },
    {
      name: ADMIN_PAGE_LABELS.admins,
      to: "/management/admins",
      icon: adminIcon,
    },
  ];
  const handleSelectAllChange = () => {
    setSelectAll(!selectAll);
  const newPermissions = {};
    Object.keys(permissionGroup).forEach((permission) => {
      newPermissions[permission] = !selectAll; // if selectAll is true, mark all as false, else mark all as true
    });
    setPermissionGroup(newPermissions); // update the entire permissions object
  };

  useEffect(() => {
    setLoading(true);
    let queryParams = `/constants`;

    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`;
    }

    getData(queryParams, true)
      .then((res) => {
        const permissions = res.data.PERMISSIONS || {};

        // Create initial form values dynamically
        const initialValues = {
          name: "",
          ...Object.keys(permissions).reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {}),
        };

        if (existingPermissionGroup) {
          const mergedValues = {
            ...initialValues,
            ...existingPermissionGroup, // Overwrite defaults with existing data
          };
          setPermissionGroup(mergedValues);
        } else {
          setPermissionGroup(initialValues);
        }
            })
      .catch((err) => toastMsg(err.response.data.message, "error"))
      .finally(() => setLoading(false));
  }, [existingPermissionGroup]);

  const [permissionGroup, setPermissionGroup] = useState({});

  // Handle input changes
  const handleChange = (event) => {
    const { name, checked } = event.target;
    setPermissionGroup((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // Handle the name input change
  const handleNameChange = (event) => {
    const { value } = event.target;
    setPermissionGroup((prev) => ({
      ...prev,
      name: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    setLoadingAdd(true);
    try {
      let res;
      if (existingPermissionGroup) {
        // If editing an existing permission group, send a PATCH request
        delete permissionGroup._id;
        delete permissionGroup.createdAt;
        delete permissionGroup.updatedAt;
        res = await patchDataToken(`/permissionGroup/${existingPermissionGroup._id}`, permissionGroup, true);
      } else {
        // If creating a new permission group, send a POST request
        res = await postData("/permissionGroup", permissionGroup, true);
      }

      toastMsg(res.data?.message, "success");
      setPermissionGroup((prev) => ({
        name: "",
        ...Object.keys(prev).reduce((acc, key) => {
          if (key !== "name") acc[key] = false;
          return acc;
        }, {}),
      }));
      setSelectAll(false);
      navigate("/management/permissiongroup")
    } catch (err) {
      toastMsg(err.response.data?.message);
    } finally {
      setLoadingAdd(false);
    }
  };
  const formatLabel = (label) => {
    return label
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase());
  };

  return {
    NavItems,
    setSearch,
    handleShow,
    teams,
    show,
    handleClose,
    handleSelect,
    selectedTeamName,
    permissionGroup,
    handleChange,
    formatLabel,
    handleSubmit,
    handleNameChange,
    setPermissionGroup,
    loadingAdd,
    selectAll,
    handleSelectAllChange,

  };
};

export default AddPermissionHooks;
